import ContentPage from '../components/ui/ContentPage';

export default function PrivacyPage(): JSX.Element {
  return (
    <ContentPage
      title="Política de privacidade"
      intro="Como tratamos os teus datos persoais, dereitos do RGPD e canles para exercelos."
      category="Legal"
      updatedAt="2026-05-19"
    >
      <h2>Responsable do tratamento</h2>
      <p>
        LeyroChain (operado por{' '}
        <strong
          style={{
            background: '#FEF3C7',
            color: '#92400E',
            padding: '2px 8px',
            borderRadius: '4px',
          }}
        >
          [RAZÓN SOCIAL — SL en constitución]
        </strong>
        , Galicia) é o responsable do tratamento dos teus datos persoais. Podes contactarnos en{' '}
        <a href="mailto:info@leyro.es">info@leyro.es</a>.
      </p>

      <h2>Que datos tratamos</h2>
      <ul>
        <li>
          <strong>Identidade</strong>: nome, email, teléfono, foto de perfil (opcional).
        </li>
        <li>
          <strong>Datos fiscais</strong>: NIF, dirección, réxime de IVA (só se publicas ou cobras
          vendas).
        </li>
        <li>
          <strong>Datos de uso</strong>: histórico de eventos rexistrados, transaccións, IP de
          inicio de sesión, dispositivos.
        </li>
        <li>
          <strong>Datos sanitarios sobre animais</strong>: vacinas, medicacións, restricións.
          Asociados ao crotal, non a ti directamente, pero a túa firma quédase no rexistro.
        </li>
      </ul>

      <h2>Base legal</h2>
      <p>
        Procesamos os teus datos por (a) execución do contrato que aceptaches ao crear conta, (b)
        cumprimento de obrigas legais — sanitarias, fiscais, EUDR — e (c) interese lexítimo no caso
        da auditoría de cadea hash.
      </p>

      <h2>Cadea hash e inmutabilidade</h2>
      <p>
        Os hashes dos eventos asinados ánclanse diariamente na blockchain Polygon. Iso significa que{' '}
        <strong>os hashes son inmutables por deseño</strong>: non se pode borrar nin alterar. O que
        está na blockchain é só o hash, non os datos persoais nin os valores brutos dos eventos.
        Para borrar a túa conta, anonimizamos os datos persoais en local; os hashes seguen apuntando
        ao "registro orixinal" pero sen poderse asociar a ti.
      </p>

      <h2>Quen accede aos teus datos</h2>
      <ul>
        <li>
          <strong>Compradores</strong> (cando reservas/recibes ofertas): só ven nome de explotación
          e concello, non datos persoais nin contacto directo.
        </li>
        <li>
          <strong>Provedores técnicos</strong>: encargados de pagamentos (PCI-DSS), verificación de
          identidade (eIDAS), almacenamento de imaxes, envío de email transaccional e sinatura
          electrónica de contratos. Cada un baixo o seu propio DPA. A relación nominal de encargados
          está dispoñible escribindo a <a href="mailto:info@leyro.es">info@leyro.es</a>.
        </li>
        <li>
          <strong>Autoridades</strong>: SITRAN, MAPA, Xunta de Galicia, Axencia Tributaria — só
          cando o esixe a lei.
        </li>
      </ul>

      <h2>Os teus dereitos</h2>
      <p>
        Podes exercer acceso, rectificación, supresión, oposición, portabilidade e limitación. Para
        iso escribe a <a href="mailto:info@leyro.es">info@leyro.es</a> ou usa as ferramentas do teu
        perfil. Tamén podes presentar unha queixa á{' '}
        <a href="https://www.aepd.es" target="_blank" rel="noreferrer">
          AEPD
        </a>
        .
      </p>

      <h2>Conservación</h2>
      <p>
        Mantemos os datos mentres a túa conta estea activa + 6 anos máis por imperativo fiscal (Lei
        58/2003). Os hashes blockchain quedan indefinidos por natureza do protocolo.
      </p>
    </ContentPage>
  );
}
